import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { useReveal } from '../hooks/useReveal';
import { SITE } from '../data/site';
import '../styles/Contactos.css';

const Contactos: React.FC = () => {
  const { ref, revealed } = useReveal<HTMLElement>();
  const { contact, social, place } = SITE;

  return (
    <>
      <SEO
        title="Contactos | Patinhas Sem Lar"
        description="Fale com a Patinhas Sem Lar para adoção, acolhimento, ajuda ou outras questões."
        path="/contactos"
      />
      <section
        ref={ref}
        className={`contactos psl-reveal${revealed ? ' is-in-view' : ''}`}
        id="contact"
      >
        <div className="contactos__inner">
          <div className="contactos__chapter">Cap. V · Contactos</div>
          <h1 className="contactos__head">
            Fala connosco —<br />
            <em>com calma, sem pressa.</em>
          </h1>

          <p className="contactos__intro">
            Respondemos a mensagens em poucos dias. Para adoção, conta-nos onde
            vives, com quem e se já tens outros animais em casa — ajuda-nos a
            perceber o melhor encaixe.
          </p>

          <div className="contactos__grid">
            <div className="contactos__card">
              <h2>Email</h2>
              <a href={`mailto:${contact.email}`}>{contact.email}</a>
              <p className="contactos__hint">
                A forma mais segura de chegar até nós. Tentamos responder dentro
                de poucos dias.
              </p>
            </div>

            <div className="contactos__card">
              <h2>Visitas e voluntariado</h2>
              <p>{contact.visiting}</p>
              <p className="contactos__hint">
                Visitas fora deste horário são por marcação.
              </p>
            </div>

            <div className="contactos__card">
              <h2>Redes sociais</h2>
              <a href={social.instagram} target="_blank" rel="noreferrer">
                Instagram @patinhassemlar
              </a>
              <a href={social.facebook} target="_blank" rel="noreferrer">
                Facebook / patinhassemlar
              </a>
            </div>

            <div className="contactos__card">
              <h2>Onde estamos</h2>
              {place.locations.map((loc) => (
                <div key={loc.label} className="contactos__location">
                  <strong>{loc.label}</strong>
                  <p>{loc.address.join(' · ')}</p>
                </div>
              ))}
              <p className="contactos__hint">
                <Link to="/onde-estamos">Ver mapa e indicações →</Link>
              </p>
            </div>
          </div>

          <p className="contactos__small-print">
            Queres apoiar mas não podes adotar?{' '}
            <Link to="/ajudar">Vê como ajudar →</Link>
          </p>
        </div>
      </section>
    </>
  );
};

export default Contactos;
